import { Controller } from "@hotwired/stimulus"

// Highlights the `<a>` whose href matches the current path with the `active`
// class. Used in `.nav-tabs`-style tab menus.
//
// Falls back to the first `<a>` if no match found.
//
// Usage:
//   <ul class="nav-tabs" data-controller="active-tab">
//     <li><a href="/cms/foo/">…</a></li>
//     <li><a href="/cms/foo/bar/">…</a></li>
//   </ul>
export default class extends Controller {
  connect() {
    const currentPath = window.location.pathname.replace(/\/?$/, '/')
    const escaped = currentPath.replace(/(["\\])/g, '\\$1')
    let link = this.element.querySelector(`a[href="${escaped}"]`)
    if (!link) link = this.element.querySelector("a")
    link?.classList.add("active")
  }
}
